import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory, useParams } from 'react-router';
import Button from '../../shared/Button';
import Header from './Header';
import Name from './Name';
import Keyword from './Keyword';
import MmeUrl from './MmeUrl';
import { setData } from '../../../features/recurringMessageSlice';

const useStyles = makeStyles(
  {
    root: {},
  },
  {
    name: 'Step1Container',
  },
);

const Step1Container = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();
  const { orgId, id } = useParams();
  const { data, isSaved, isActive } = useSelector(
    store => store.recurringMessage,
  );
  const { name, keyword, ref } = data || {};

  const handleNameChange = value => {
    dispatch(
      setData({
        name: value,
      }),
    );
  };

  const handleKeywordChange = value => {
    dispatch(
      setData({
        keyword: value,
      }),
    );
  };

  const handleRefChange = value => {
    dispatch(
      setData({
        ref: value,
      }),
    );
  };

  const handleNext = () => {
    history.push(`/recurringMessage/${orgId}/${id}/step2`);
  };

  return (
    <div className={classes.root}>
      <Header />
      <Name
        name={name}
        onChange={handleNameChange}
        isSaved={isSaved}
        disabled={isActive}
      />
      <Keyword
        keyword={keyword}
        onChange={handleKeywordChange}
        isSaved={isSaved}
        disabled={isActive}
      />
      <MmeUrl customRef={ref} onChange={handleRefChange} disabled={isActive} />
      <Button topic="primaryGreen" onClick={handleNext}>
        {t('next')}
      </Button>
    </div>
  );
};

export default Step1Container;
